// Google Tag Manager dataLayer helper
// Pushes structured events to GTM (GTM-WMRPTQF3) for downstream GA4/Ads tracking.

const isBrowser = () => typeof window !== 'undefined';

const ensureDataLayer = () => {
  if (!isBrowser()) return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const gtmPush = (event, params = {}) => {
  const dl = ensureDataLayer();
  if (!dl) return;
  dl.push({ event, ...params });
};

// Page-level helpers
export const trackCTA = (cta_id, location, extra = {}) => {
  gtmPush('cta_click', { cta_id, cta_location: location, ...extra });
};

export const trackBookCall = (source, extra = {}) => {
  gtmPush('book_call_click', { source, ...extra });
};

export const trackServiceView = (service_slug) => {
  gtmPush('service_view', { service_slug });
};

export const trackCaseStudyView = (slug, client) => {
  gtmPush('case_study_view', { case_study_slug: slug, client });
};

export const trackFormSubmit = (form_id, fields_count) => {
  gtmPush('form_submit', { form_id, fields_count });
};

export const trackBlogView = (slug, title) => {
  gtmPush('blog_view', { blog_slug: slug, blog_title: title });
};
